import { render, staticRenderFns } from "./newChargeGroup.vue?vue&type=template&id=95ea94fe&"
import script from "./newChargeGroup.vue?vue&type=script&lang=js&"
export * from "./newChargeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95ea94fe')) {
      api.createRecord('95ea94fe', component.options)
    } else {
      api.reload('95ea94fe', component.options)
    }
    module.hot.accept("./newChargeGroup.vue?vue&type=template&id=95ea94fe&", function () {
      api.rerender('95ea94fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/newChargeGroup.vue"
export default component.exports